"use strict";

$(document).ready(function(){
	var crmType = custom.crm;

	var popupSetting = custom.popup;
	if(popupSetting == 1){
		if(window.location.pathname == '/' || '/splash'){
			// popup
			if(!$.cookie('popup')){
				$('#popup').addClass('popup--enable');

				var date = new Date();
				date.setTime(date.getTime() + 7 * 24 * 60 * 60 * 1000); 
			}

			if($.cookie('popup')){
				$('#popup').addClass('popup--disable');

				$('.popup').remove();
				$('body').removeClass('popup--active');
				$('body').addClass('popup--inactive');
			}			

			$('.popup__close, .popup__btn--text, .popup__content a.cta__btn').click(function(){
				$('body').removeClass('popup--active');
				$('body').addClass('popup--inactive');
				$('.popup').fadeOut(500, function(){
					$(this).remove();
				});
				$.cookie('popup', true, { expires: date });
			});

			if(crmType == 'action-network'){
				$(document).on('web-popup_submitted', function(){
					$('body').removeClass('popup--active');
					$('body').addClass('popup--inactive');
					$('.popup').fadeOut(500, function(){
						$(this).remove();
					});
					$.cookie('popup', true, { expires: date });
				});
			}
			if(crmType == 'actionkit'){
				$('.popup form').bind('ajax:complete', function(){
					$('body').removeClass('popup--active');
					$('body').addClass('popup--inactive');
					$('.popup').fadeOut(500, function(){
						$(this).remove();
					});
					$.cookie('popup', true, { expires: date });					
				});
			}
		}
	}

	var alertSetting = custom.alert;
	if(alertSetting == 1){
		// alert
		if(!$.cookie('alert')){
			var popup = document.getElementById('alert');
			popup.classList.add('alert--enable');

			var date = new Date();
			date.setTime(date.getTime() + 7 * 24 * 60 * 60 * 1000); 
		}

		if($.cookie('alert')){
			$('.alert').remove();
		}

		$('.alert__close').click(function(){
			$('.alert').remove();
			$.cookie('alert', true, { expires: date });
		});
	}

	// mobile nav
    $('.header__nav--mobile').click(function(){
        $('.hamburger').toggleClass('is-active');
        if($('.hamburger').hasClass('is-active')){
			// $('body').css({'position' : 'fixed'});
			$('.header__nav').css({'display' : 'flex'});
			$('.header__nav--wrap').addClass('is-active');
        } else{
			// $('body').css({'position' : 'relative'});
			$('.header__nav').css({'display' : 'none'});
			$('.header__nav--wrap').removeClass('is-active');
        }
    });

	// action network
	if(crmType == 'action-network'){
		if(window.location.pathname == '/' ){
			// featured
			$(document).on('web-featured_loaded', function(){
				$('#can_embed_form_inner > h2').remove();
				$('#can_embed_form_inner > h3').remove();
				$('#can_embed_form_inner > h4').remove();
				$('li.form_builder_output').remove();
				$('input#form-email').attr('placeholder', 'Email Address*');
				$('input#form-zip_code').attr('placeholder', 'Zip Code*');
				$('input#form-phone').attr('placeholder', 'Mobile Number');
				$('input[name="subscription[sms_group]"]').prop('checked', true);
				$('#web-footer-cta #mobile_opt_in_default').html('By providing your cell phone number you consent to receive recurring text message updates from Democracy Defenders PAC, including by automated text message. Text STOP to end. Msg & Data rates may apply. <a href="/privacy-policy/">Privacy Policy & Terms and Conditions.</a>');
				$('#action_info').remove();
				$('#logo_wrap').remove();
				$('span.international_link-wrap').remove();
				$('#can_embed_form .core_field #form-zip_code:not(.mb_needed)').css('margin-bottom', '6px!important');
			});
		}

		// footer cta
		$(document).on('web-footer-cta_loaded', function(){
			$('#can_embed_form_inner > h2').remove();
			$('#can_embed_form_inner > h3').remove();
			$('#can_embed_form_inner > h4').remove();
			$('li.form_builder_output').remove();
			$('input#form-email').attr('placeholder', 'Email Address*');
			$('input#form-zip_code').attr('placeholder', 'Zip Code*');
			$('input#form-phone').attr('placeholder', 'Mobile Number');
			$('input[name="subscription[sms_group]"]').prop('checked', true);
			$('#web-footer-cta #mobile_opt_in_default').html('By providing your cell phone number you consent to receive recurring text message updates from Democracy Defenders PAC, including by automated text message. Text STOP to end. Msg & Data rates may apply. <a href="/privacy-policy/">Privacy Policy & Terms and Conditions.</a>');
			$('#action_info').remove();
			$('#logo_wrap').remove();
			$('span.international_link-wrap').remove();
			$('#can_embed_form .core_field #form-zip_code:not(.mb_needed)').css('margin-bottom', '6px!important');
		});
	}

	// heading
	var hed = document.querySelectorAll('[class$=__hed] > span');
	var i;
	for(i = 0; i < hed.length; i++){
		hed[i].innerHTML += '<svg class="link-svgline"><use xlink:href="#svg_line"></use></svg>';
	}

	// recurring
	$('.cta__monthly--btn').click(function(){
		$('button.cta__monthly--btn.cta__monthly--btn-active').removeClass('cta__monthly--btn-active');
		$(this).addClass('cta__monthly--btn-active');

		var urls = document.querySelectorAll('.footer__cta--contrib a.cta__btn');
		var yes = document.getElementById('monthly-yes');
		var no = document.getElementById('monthly-no');

		$(yes).click(function(){
			$(urls).each(function(i){
				var domains = urls[i].hostname;
	
				if(domains == 'secure.actblue.com'){
					var oldUrl = urls[i].href;

					var searchParams = new URLSearchParams(oldUrl);
					var monthly = searchParams.get('recurring');

					if(monthly == 'false'){
						var newUrl = oldUrl.replace('&recurring=false', '&recurring=true');
					}
				}
				else if(domains == 'secure.ngpvan.com' || 'secure.everyaction.com'){
					var oldUrl = urls[i].href;

					var searchParams = new URLSearchParams(oldUrl);
					var monthly = searchParams.get('r');

					if(monthly == 'false'){
						var newUrl = oldUrl.replace('&r=false', '&r=true');
					}
				}

				$(this).attr('href', newUrl);
			});
		});

		$(no).click(function(){
			$(urls).each(function(i){
				var domains = urls[i].hostname;
	
				if(domains == 'secure.actblue.com'){
					var oldUrl = urls[i].href;

					var searchParams = new URLSearchParams(oldUrl);
					var monthly = searchParams.get('recurring');

					if(monthly == 'true'){
						var newUrl = oldUrl.replace('&recurring=true', '&recurring=false');
					}
				}
				else if(domains == 'secure.ngpvan.com' || 'secure.everyaction.com'){
					var oldUrl = urls[i].href;

					var searchParams = new URLSearchParams(oldUrl);
					var monthly = searchParams.get('r');

					if(monthly == 'true'){
						var newUrl = oldUrl.replace('&r=true', '&r=false');
					}
				}

				$(this).attr('href', newUrl);
			});
		});
	});
	
	// lity
	$('.wp-block-image img').attr('data-lity', '');

	// aos
	AOS.init({
		easing: 'ease',
		duration: 1500
	});

	// current year
	document.getElementById('year').appendChild(document.createTextNode(new Date().getFullYear()));

	// anchors
	$(function(){
		$('a[href*="#"]:not([href="#"])').click(function(){
			if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname){
				var target = $(this.hash);
				target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
				if(target.length){
					$('html, body').animate({
						scrollTop: target.offset().top
					}, 0);
					return false;
				}
			}
		});
	});
});